<template>
  <div>
    <!-- 顶部导航（吸顶） -->
    <TopNav />
    <!-- 主页内容 -->
    <main class="content">
      <!-- 轮播 Banner -->
      <HomeBanner />
      <!-- 业务板块 -->
      <BusinessModule />
      <!-- 新闻资讯板块 -->
      <NewsSection />
      <!-- 资源 / 快速入口 -->
      <ResourceLinks />
      <AppFooter />
    </main>
  </div>
</template>
<script>
import TopNav from '@/components/TopNav.vue'
import HomeBanner from '@/components/HomeBanner.vue'
import BusinessModule from '@/components/BusinessModule.vue'
import NewsSection from '@/components/NewsSection.vue'
import ResourceLinks from '@/components/ResourceLinks.vue'
import AppFooter from '@/components/AppFooter.vue'
export default {
  name: 'HomeView',
  components: {
    TopNav,
    HomeBanner,
    BusinessModule,
    NewsSection,
    ResourceLinks,
    AppFooter
  }
}
</script>
<style scoped>
/* 吸顶导航高度 64px，内容整体下移 */
.content {
  padding-top: 64px;
}
/* 通用内容区样式（如后续再加模块可复用） */
.section {
  padding: 60px 80px;
}
.section h3 {
  font-size: 24px;
  margin-bottom: 16px;
  color: #333;
}
.section p {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
}
</style>
